// Campus photo for /colleges/quinnipiac-university: CC BY-SA 3.0, by Wasted Time R, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AQuinnipiac_University_Arnold_Bernhard_Library.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/quinnipiac-university/; credited under the photo.
const photo = {
    "slug": "quinnipiac-university",
    "alt": "The Arnold Bernhard Library clock tower on the quad at Quinnipiac University in Hamden, Connecticut, with Sleeping Giant behind",
    "src": "/colleges/quinnipiac-university/campus-1600.webp",
    "srcSmall": "/colleges/quinnipiac-university/campus-800.webp",
    "srcMid": "/colleges/quinnipiac-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/quinnipiac-university/og.jpg",
    "title": "Quinnipiac University Arnold Bernhard Library",
    "author": "Wasted Time R",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AQuinnipiac_University_Arnold_Bernhard_Library.jpg",
    "read": "2026-10-02"
};

export default photo;
